import request from '@/utils/request'
const api_name = 'contract'
export default{
    getAllContracts(){
        return request({
            url:`/${api_name}/getallcontracts`,
            method:'get'
        })
    },
    getContractsByContractSubject(pojo){
        return request({
            url:`/${api_name}/getcontractbycontractsubject`,
            method:'post',
            data:pojo
        })
    },
    getContractByContractNo(pojo){
        return request({
            url:`/${api_name}/getcontractbycontractno`,
            method:'post',
            data:pojo
        })
    },
    addContract(pojo){
        return request({
            url:`/${api_name}/addcontract`,
            method:'post',
            data:pojo
        })
    },

    updateContract(pojo){
        return request({
            url:`/${api_name}/updatecontract`,
            method:'post',
            data:pojo
        })
    },
    deleteContract(id){
        return request({
            url:`/${api_name}/deletecontract?contractid=`+id,
            method:'delete',
        })
    },
    
}







